<template>
<div class="chapter">
<div class="inner_page">
<p class="c2" id="calibre_pb_5">John N.</p>
<p class="c1">…find me.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_10b66645e68cd802cc2e2d6047672dad_2rfwv1.ch.fixed.fc.tidied.stylehacked.xfixed_split_006.vue?7d991c76